import { ADMIN, COMMON, ifyouApi, ifyouApiLive } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

export const oldNoticeApi = {
  read: (projectId: string | number = -1) =>
    ifyouApi
      .post(`${ADMIN}/com-notice-list`, { connected_project: projectId })
      .then((res) => res.data),
  detail: (noticeNo) =>
    ifyouApi
      .post(`${ADMIN}/com-notice-detail-all`, { notice_no: noticeNo })
      .then((res) => res.data),
  register: ({ detailData, resultArr }) =>
    ifyouApi
      .post(`${ADMIN}/com-notice-insert`, {
        notice_type: detailData.notice_type,
        notice_name: detailData.notice_name,
        is_public: detailData.is_public,
        start_date: detailData.start_date,
        end_date: detailData.end_date,
        os: detailData.os,
        exception_culture: detailData.exception_culture,
        connected_project: detailData.connected_project,
        langList: resultArr,
      })
      .then((res) => res.data),
  update: ({ detailData, langList }) =>
    ifyouApi
      .post(`${ADMIN}/com-notice-update`, {
        notice_no: detailData.notice_no,
        notice_type: detailData.notice_type,
        notice_name: detailData.notice_name,
        is_public: detailData.is_public,
        start_date: detailData.start_date,
        end_date: detailData.end_date,
        os: detailData.os,
        exception_culture: detailData.exception_culture,
        connected_project: detailData.connected_project,
        langList: langList,
      })
      .then((res) => res.data),
  delete: ({ noticeId }) =>
    ifyouApi
      .post(`${ADMIN}/com-notice-delete`, {
        notice_no: noticeId,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  sorting: (rows) =>
    ifyouApi
      .post(`${ADMIN}/com-notice-sorting`, {
        rows: rows,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};

export const noticeApisLIVE = {
  read_LIVE: () =>
    ifyouApiLive
      .post(`${ADMIN}/com-notice-list`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  detail_LIVE: (noticeNo) =>
    ifyouApiLive
      .post(`${ADMIN}/com-notice-detail-all`, { notice_no: noticeNo })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  create_LIVE: (inputData, langData) =>
    ifyouApiLive
      .post(`${ADMIN}/com-notice-insert`, {
        notice_type: inputData.notice_type,
        notice_name: inputData.notice_name,
        is_public: inputData.is_public,
        start_date: inputData.start_date,
        end_date: inputData.end_date,
        os: inputData.os,
        langList: langData,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  update_LIVE: (inputData, langList) =>
    ifyouApiLive
      .post(`${ADMIN}/com-notice-update`, {
        notice_no: inputData.notice_no,
        notice_type: inputData.notice_type,
        notice_name: inputData.notice_name,
        is_public: inputData.is_public,
        start_date: inputData.start_date,
        end_date: inputData.end_date,
        os: inputData.os,
        langList: langList,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  delete_LIVE: (noticeId) =>
    ifyouApiLive
      .post(`${ADMIN}/com-notice-delete`, {
        notice_no: noticeId,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  sorting_LIVE: (rows) =>
    ifyouApiLive
      .post(`${ADMIN}/com-notice-sorting`, {
        rows: rows,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};

export const fetchNoticeDropList = {
  detailImageList: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'projectImageList',
        code: 'notice_detail',
        project_id: projectId,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  bannerImageList: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'projectImageList',
        code: 'notice_banner',
        project_id: projectId,
      })
      .then((res) => res.data),
};

export const fetchNoticeDropList_LIVE = {
  detailImageList: () =>
    ifyouApiLive
      .post(`${COMMON}`, {
        func: 'projectImageList',
        code: 'notice_detail',
        project_id: -1,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  bannerImageList: () =>
    ifyouApiLive
      .post(`${COMMON}`, {
        func: 'projectImageList',
        code: 'notice_banner',
        project_id: -1,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};
